import React from "react";
import PropTypes from "prop-types";
import { Routes, Route, useLocation } from "react-router-dom";
import StampForm from "./pages/StampForm";
import VerifyForm from "./pages/VerifyForm";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";

import UserProfile from "./pages/UserProfile";
import PricingForm from "./pages/PricingForm";
import UserFound from "./pages/UserFound";
import Reports from "./pages/Reports";
import ReportsProducer from "./pages/ReportsProducer";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";
import SubscriptionNotFoundPage from "./pages/SubscriptionNotFoundPage";

const App = ({ props, djangoContext, staticBasePath, theme }) => {
  const location = useLocation();
  return (
    <MantineProvider withGlobalStyles withNormalizeCSS theme={theme}>
      <Notifications />
      <Header
        {...props}
        djangoContext={djangoContext}
        staticBasePath={staticBasePath}
      />

      <Routes>
        <Route
          path="/stamp"
          element={
            <StampForm
              key={location.key}
              {...props}
              djangoContext={djangoContext}
              staticBasePath={staticBasePath}
            />
          }
        />
        <Route
          path="/verify"
          element={
            <VerifyForm
              key={location.key}
              {...props}
              djangoContext={djangoContext}
              staticBasePath={staticBasePath}
            />
          }
        />
        <Route
          path="/profile"
          element={
            <UserProfile
              {...props}
              djangoContext={djangoContext}
              staticBasePath={staticBasePath}
            />
          }
        />
        <Route
          path="/profile/payment/"
          element={
            <PricingForm
              {...props}
              djangoContext={djangoContext}
              staticBasePath={staticBasePath}
            />
          }
        />
        <Route
          path="/verify/user-data/"
          element={
            <UserFound
              {...props}
              djangoContext={djangoContext}
              staticBasePath={staticBasePath}
            />
          }
        />
        <Route
          path="/reports/"
          element={
            <Reports
              {...props}
              djangoContext={djangoContext}
              staticBasePath={staticBasePath}
            />
          }
        />
        <Route
          path="/reports/producer/"
          element={
            <ReportsProducer
              {...props}
              djangoContext={djangoContext}
              staticBasePath={staticBasePath}
            />
          }
        />
        <Route
          path="/paddle/subscription-success/:transactionId/"
          element={
            <SubscriptionSuccessPage
              {...props}
              djangoContext={djangoContext}
              staticBasePath={staticBasePath}
            />
          }
        />
        <Route
          path="/paddle/subscription-failed/:transactionId/"
          element={
            <SubscriptionNotFoundPage
              {...props}
              djangoContext={djangoContext}
              staticBasePath={staticBasePath}
            />
          }
        />
      </Routes>

      <Footer {...props} staticBasePath={staticBasePath} />
    </MantineProvider>
  );
};

App.propTypes = {
  props: PropTypes.object,
  djangoContext: PropTypes.object,
  staticBasePath: PropTypes.string,
  theme: PropTypes.object,
};

export default App;
